import React from 'react'
import Modal from '../../../Modal';
import removeImg from '../../../../static/images/remove.png';
import downloadImg from '../../../../static/images/download.png';
import Image from 'components/Image';
import { FORMAT_DATE, FORMAT_DATE_TIME } from '../mle.constants';
import moment from 'moment';
import './style.scss';

const ImageViewModal = ({
    selectedDocument,
    setSelectedDocument,
}) => {
    let timeStamp = null;

    if (selectedDocument) {
        try {
            const url = new URL(selectedDocument);
            const amzDate = url.searchParams.get('X-Amz-Date');

            if (amzDate && amzDate.length >= 15) {
                const parsedMoment = moment.utc(amzDate, 'YYYYMMDDTHHmmss[Z]');
                timeStamp = parsedMoment.format('YYYY-MM-DD HH:mm:ss');
            }
        } catch (err) {
            console.error('Invalid URL in selectedDocument:', err);
        }
    }

  return (
      <Modal
          modalIsOpen={selectedDocument}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
          closeModal={() => setSelectedDocument(null)}
          customWrapperClass="content-modal modal-xl"
      >
          <div className="modal-header" style={{ position: 'relative', zIndex: 9999 }}>
              <h2 className="modal-heading">
                {!timeStamp && (
                    <span>Document View</span>
                )}
                {timeStamp && (
                    <>
                        <span className='title'>
                            Uploaded on
                        </span>
                        <span className='time-stamp'>
                            &nbsp;
                            {timeStamp}
                        </span>
                    </>
                )}
              </h2>
              <button 
                  onClick={(e) => {
                      e.stopPropagation();
                      setSelectedDocument(null);
                  }}
                  style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '8px',
                      position: 'absolute',
                      right: '20px',
                      top: '50%',
                      transform: 'translateY(-50%)'
                  }}
              >
                  <img
                      src={removeImg}
                      alt="Close"
                  />
              </button>
          </div>
          <div className="modal-body">
              {selectedDocument && selectedDocument.includes('.pdf') ? (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                    <div style={{ flex: 1, overflow: 'hidden' }}>
                    <object
                    data={selectedDocument}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                  >
                    <p>Your browser does not support PDFs. <a href={selectedDocument}>Download the PDF</a>.</p>
                  </object>
                  </div>
                </div>
              ) : (
                  <Image
                      src={selectedDocument}
                      alt="selectedDocument"
                  />
              )}
              <img
                  src={downloadImg}
                  alt="Downlaod"
                  className="download-image"
                  onClick={() => window.open(selectedDocument)}
              />
          </div>
      </Modal>
  );
}

export default ImageViewModal












// import React from 'react'
// import Modal from '../../../Modal';
// import removeImg from '../../../../static/images/remove.png';
// import downloadImg from '../../../../static/images/download.png';
// import Image from 'components/Image';

// const ImageViewModal = ({
//     selectedDocument,
//     setSelectedDocument,
// }) => {
//   return (
//       <Modal
//           modalIsOpen={selectedDocument}
//           shouldCloseOnOverlayClick
//           shouldCloseOnEsc
//           closeModal={() => setSelectedDocument(null)}
//           customWrapperClass="content-modal modal-xl"
//       >
//           <div className="modal-header" style={{ position: 'relative', zIndex: 9999 }}>
//               <h2 className="modal-heading">Document View</h2>
//               <button 
//                   onClick={(e) => {
//                       e.stopPropagation();
//                       setSelectedDocument(null);
//                   }}
//                   style={{
//                       background: 'none',
//                       border: 'none',
//                       cursor: 'pointer',
//                       padding: '8px',
//                       position: 'absolute',
//                       right: '20px',
//                       top: '50%',
//                       transform: 'translateY(-50%)'
//                   }}
//               >
//                   <img
//                       src={removeImg}
//                       alt="Close"
//                   />
//               </button>
//           </div>
//           <div className="modal-body">
//               {selectedDocument && selectedDocument.includes('.pdf') ? (
//                     <object
//                     data={selectedDocument}
//                     type="application/pdf"
//                     width="100%"
//                     height="100%"
//                   >
//                     <p>Your browser does not support PDFs. <a href={selectedDocument}>Download the PDF</a>.</p>
//                   </object>
//               ) : (
//                   <Image
//                       src={selectedDocument}
//                       alt="selectedDocument"
//                   />
//               )}
//               <img
//                   src={downloadImg}
//                   alt="Downlaod"
//                   className="download-image"
//                   onClick={() => window.open(selectedDocument)}
//               />
//           </div>
//       </Modal>
//   );
// }

// export default ImageViewModal